<template>
  <div class="flex-shrink-0 overflow-hidden flex items-center justify-center font-bold ring-1 ring-black/5 dark:ring-white/10"
    :class="[sizes[size], img ? 'bg-white' : tint]" aria-hidden="true">
    <img v-if="img" :src="src" alt="" referrerpolicy="no-referrer" loading="lazy" class="w-full h-full object-contain" @error="failed = true">
    <span v-else>{{ letter }}</span>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'

const props = defineProps({
  name: { type: String, default: '' },
  src: { type: String, default: null },
  size: { type: String, default: 'md' }, // xs | sm | md | lg
})

const sizes = {
  xs: 'w-5 h-5 rounded text-[10px]',
  sm: 'w-8 h-8 rounded-lg text-sm',
  md: 'w-11 h-11 rounded-xl text-base',
  lg: 'w-16 h-16 rounded-2xl text-2xl',
}

// One soft colour per name, so a company without a logo is still easy to tell apart at a glance.
const TINTS = [
  'bg-blue-50 text-blue-600 dark:bg-blue-900/30 dark:text-blue-300',
  'bg-violet-50 text-violet-600 dark:bg-violet-900/30 dark:text-violet-300',
  'bg-emerald-50 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-300',
  'bg-amber-50 text-amber-600 dark:bg-amber-900/30 dark:text-amber-300',
  'bg-rose-50 text-rose-600 dark:bg-rose-900/30 dark:text-rose-300',
  'bg-cyan-50 text-cyan-600 dark:bg-cyan-900/30 dark:text-cyan-300',
  'bg-indigo-50 text-indigo-600 dark:bg-indigo-900/30 dark:text-indigo-300',
  'bg-teal-50 text-teal-600 dark:bg-teal-900/30 dark:text-teal-300',
]

// Company logo links can expire, so a logo that fails to load shows the company's initial.
const failed = ref(false)
watch(() => props.src, () => { failed.value = false })

const img = computed(() => Boolean(props.src) && !failed.value)
const letter = computed(() => (props.name || '?').trim().charAt(0).toUpperCase() || '?')
const tint = computed(() => TINTS[[...(props.name || '?')].reduce((sum, char) => sum + char.charCodeAt(0), 0) % TINTS.length])
</script>
